import CompanyAdditionalFieldsForm from "../components/company-additional-fields/CompanyAdditiionalFieldsForm";

const CompanyAdditionalFieldsPage = () => {
  return <CompanyAdditionalFieldsForm />;
};

export default CompanyAdditionalFieldsPage;
